import MultiSelect from 'primevue/multiselect'
import { AVAILABLE_EXCHANGES } from '@/utils/consts'
import { i18n } from '@/i18n'
import { markRaw } from 'vue'
import { z } from 'zod'
import SrInputNumber from '@/components/SrInputNumber.vue'
import { srZodNumber } from '@/utils'

export function createTickersFilters() {
  const { t } = i18n.global
  const swapFilters = [
    {
      header: 'exchanges',
      field: 'exchanges',
      component: markRaw(MultiSelect),
      placeholder: 'Gate, Mexc, Ourbit, Lbank',
      zod: z.string().array().optional().nullable(),
      containerClass: 'md:col-span-2',
      props: {
        filterMatchMode: 'startsWith',
        showClear: true,
        options: AVAILABLE_EXCHANGES,
        optionLabel: 'title',
        optionValue: 'value',
        filter: true,
        emptyFilterMessage: t('emptyMessage'),
      },
    },
    {
      field: 'change_min',
      header: 'change',
      component: markRaw(SrInputNumber),
      placeholder: '5',
      zod: srZodNumber(),
      props: {
        step: 0.5,
        showButtons: true,
        maxFractionDigits: 2,
      },
    },
    {
      field: 'vol24h',
      header: 'vol24h',
      component: markRaw(SrInputNumber),
      placeholder: '100 000',
      zod: srZodNumber(),
      props: {
        step: 1000,
        showButtons: true,
        maxFractionDigits: 2,
      },
    },
  ]
  return swapFilters
}
